import { Card, CardContent } from "../../components/ui/card";
import { UtensilsCrossed, Check, Percent, Euro } from "lucide-react";

const StatCard = ({ icon: Icon, iconBg, iconColor, label, value }) => (
  <Card className="bg-white">
    <CardContent className="p-4">
      <div className="flex items-center gap-3">
        <div className={`p-2 rounded-xl ${iconBg}`}>
          <Icon className={`w-5 h-5 ${iconColor}`} />
        </div>
        <div>
          <p className="text-xs text-gray-500">{label}</p>
          <p className="text-xl font-bold text-gray-900">{value}</p>
        </div>
      </div>
    </CardContent>
  </Card>
);

const MenuStatsCards = ({ stats }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
    <StatCard
      icon={UtensilsCrossed}
      iconBg="bg-[#FF6584]/10"
      iconColor="text-[#FF6584]"
      label="Totale Prodotti"
      value={stats.totale}
    />
    <StatCard
      icon={Check}
      iconBg="bg-green-100"
      iconColor="text-green-600"
      label="Attivi"
      value={stats.attivi}
    />
    <StatCard
      icon={Percent}
      iconBg="bg-blue-100"
      iconColor="text-blue-600"
      label="Margine Medio"
      value={`${stats.margineMediano}%`}
    />
    <StatCard
      icon={Euro}
      iconBg="bg-orange-100"
      iconColor="text-orange-600"
      label="Food Cost Medio"
      value={`€${stats.foodCostMedio}`}
    />
  </div>
);

export default MenuStatsCards;
